import EnvironmentConfig from '../interfaces/EnvironmentConfig';

const qaConfigs: EnvironmentConfig = {
  surveyJsKey:
    'NzQ2YTcwNDMtMDcxMS00NjhkLWIyZjYtNDBmOTJjOTQwMzU3JmRvbWFpbnM6ZGFzaGJvYXJkLmNhc2FxYS5hamlyYS50ZWNoOzE9MjAyNS0wMy0wNywyPTIwMjUtMDMtMDcsND0yMDI1LTAzLTA3',
  ingressUrl:"https://ingress.casaqa.ajira.tech",
  dashboardClassic: 'https://dashboard-classic.casaqa.ajira.tech',
  ruleServerUrl: 'https://api.casaqa.ajira.tech',
  apiServerUrl: 'https://api.customerstudioqa.ajira.tech',
  casaWebAppUrl: 'https://web.casaqa.ajira.tech',
  commerceConnect: 'https://commerce-connect.casaqa.ajira.tech',
  pwaUrl: 'qa.casarewards.com',
  dashboard: 'https://dashboard.casaqa.ajira.tech',
  tenantOnboardUrl: 'https://admin.qa.casaretail.ai',
  supersetUrl: 'https://analytics.casaqa.ajira.tech',
  ruleUIUrl: 'https://rules.casaqa.ajira.tech',
  systemPage: true,
  allJourneyFeatures: true,
  ticketDeskUrl: 'https://ticket-desk.casaqa.ajira.tech',
  keycloakConfig: {
    url: `https://auth.qa.casaretail.ai`,
    realm: `casa`,
    clientId: `casa_dashboard`,
  },
  socialMedia: {
    facebook: {
      appId: '1131725099349217',
      configId: '2606713429839738',
    },
    googleAds: {
      clientId:
        '273230167843-mdnnlq3creq5jouop3kfbvsjg2mqmpl6.apps.googleusercontent.com',
      redirectURI:
        'https://dashboard.casaqa.ajira.tech/settings/integrations/social-media',
    },
  },
};

export default qaConfigs;
